export const environment = {
    production: true,
    SUPABASE_URL: 'https://axpuflrsqvwgperujshf.supabase.co',
    SUPABASE_KEY: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImF4cHVmbHJzcXZ3Z3BlcnVqc2hmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MjU2NzcyNjcsImV4cCI6MjA0MTI1MzI2N30.iz_hqvUAFN87Y1dPM8Ky-ZSVxK9TnmV71TYPZ_Pq3QE',
    API_URL: 'https://ts-gpu-04.walleye-climb.ts.net/',

    // Imaxine license project (read-only, publishable key): license list page + expiry banner
    SUPABASE_URL_IMAXINE: 'https://ckprspbmxurzwywfntse.supabase.co',
    SUPABASE_KEY_IMAXINE: 'sb_publishable_wDPZsvX6emPW4EEXKEyxAg_NHvM86Gu',
    ENCRYPTION_KEY: '66mG8oKeeG02wa5bkUjSneUiWwj_jtDDHkJuRh1sJ_c=', // Fernet key (32 bytes base64url) for license encryption/decryption

};
